// config.js — tunable constants. No DOM, no logic.

export const GRID = {
    cols: 6,
    rows: 4,
};

// Step budget per line = number of bars (kanji) + STEP_SLACK.
// GDD example: 10 kanji -> 12 steps (slack of 2 to recover from wrong turns).
export const STEP_SLACK = 2;

// TextAlive app token (from https://developer.textalive.jp/profile).
export const TEXTALIVE_TOKEN = "eaFarhRWbobOZTyd";

// Default song: "After the Curtain / Rulmry".
export const DEFAULT_SONG = {
    url: "https://piapro.jp/t/zoqO/20251214200738",
    video: {
        beatId: 4827294,
        chordId: 2963755,
        repetitiveSegmentId: 3086262,
        lyricId: 126591,
        lyricDiffId: 28627,
    },
};
